/**
 * Promo code hooks -- TanStack Query mutations.
 */
import { useMutation } from '@tanstack/react-query'
import { promoService } from '../services/promo.service'

export function useValidatePromo() {
  return useMutation({
    mutationFn: ({
      code,
      userId,
      subtotalCents,
    }: {
      code: string
      userId: string
      subtotalCents: number
    }) => promoService.validatePromoCode(code, userId, subtotalCents),
  })
}
